import { render, staticRenderFns } from "./editCode.vue?vue&type=template&id=6b6a9899&scoped=true&"
import script from "./editCode.vue?vue&type=script&lang=js&"
export * from "./editCode.vue?vue&type=script&lang=js&"
import style0 from "./editCode.vue?vue&type=style&index=0&id=6b6a9899&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a9899",
  null
  
)

export default component.exports